const swagger = {
    invalid_zod_type: 'Type Zod non valide. Veuillez vérifier la configuration du garde-route.',
    not_supported_zod_type_for_params: 'Type Zod non supporté pour les paramètres. Veuillez vérifier la configuration du garde-route.',
};
export default swagger;
